module.exports = __webpack_public_path__ + "static/for-the-office-PPT-51c9bb73f02008ddcd6643113da3994d.jpg";